import { pick } from 'lodash-es'
import { API } from '#app/lib/api/api'
import preq, { treq } from '#app/lib/preq'
import type { PostTransactionMessageResponse } from '#server/controllers/transactions/post_message'
import type { TransactionComment } from '#server/types/comment'
import type { ItemId } from '#server/types/item'
import { getTransactions } from '#transactions/lib/get_transactions'
import { getActiveTransactionsByItemId, serializeTransaction, type SerializedTransaction } from '#transactions/lib/transactions'
import { mainUser } from '#user/lib/main_user'

const transactions = await getTransactions()

export async function postTransactionMessage ({ transaction, message }: { transaction: SerializedTransaction, message: string }) {
  const messageData = {
    action: 'message',
    transaction: transaction._id,
    message,
  }
  const { id: commentId, rev: commentRev } = await treq.post<PostTransactionMessageResponse>(API.transactions.base, messageData)
  const comment: TransactionComment = {
    _id: commentId,
    _rev: commentRev,
    ...pick(messageData, [ 'transaction', 'message' ]),
    user: mainUser._id,
    created: Date.now(),
  }
  transaction.messages.push(comment)
  return transaction
}

export function hasOngoingTransactionsByItemIdSync (itemId: ItemId) {
  return transactions.find(transaction => transaction.item === itemId && !transaction.archived) != null
}

export async function postTransactionRequest ({ itemId, message }: { itemId: ItemId, message: string }) {
  try {
    const { transaction } = await preq.post(API.transactions.base, {
      action: 'request',
      item: itemId,
      message,
    })
    const serializedTransaction = serializeTransaction(transaction)
    transactions.unshift(serializedTransaction)
    return serializedTransaction
  } catch (err) {
    // This case should normally not be possible, as UI elements should not offer to request
    // an item already requested, but it might not have worked if hasOngoingTransactionsByItemIdSync was not ready
    if (err.message === 'user already made a request on this item') {
      const transactions = await getActiveTransactionsByItemId(itemId)
      if (transactions[0]) return serializeTransaction(transactions[0])
    }
    throw err
  }
}
